<template>
  <div v-show="sharable" class="order-share-tips c:row-end-center">
    <span>点击右上角</span>
    <img class="find-more-icon" src="@/assets/icons/find-more.svg" alt="" />
    <span v-if="order.status === 0">分享支付链接到客人聊天窗口</span>
    <span v-else-if="order.status === 20">转发给客人选择取货方式</span>
    <span v-else>转发订单给客人</span>
    <div class="upward"><img src="@/assets/icons/upward.svg" alt="" /></div>
  </div>
</template>

<script>
import { changeOrderApi } from "@/api";
import { getAdjustPriceStatus } from "@/utils";
import { mapState } from "vuex";

export default {
  props: {
    order: Object,
    isCreator: Boolean,
    isBaseOrder: Boolean,
    refundStatus: Object,
  },
  computed: {
    ...mapState(["user", "brandInfo"]),
    sharable() {
      if (this.isCreator) {
        if (this.order?.status === 0) {
          const adjustPriceStatus = getAdjustPriceStatus(this.order);
          return adjustPriceStatus.pending === 0;
        }
        if (this.isBaseOrder && this.order?.status === 20) {
          return !this.refundStatus.isRefundingOrDone;
        }
      }
      return false;
    },
  },
  watch: {
    sharable: {
      immediate: true,
      handler() {
        try {
          wx.ready(() => {
            const adjustPriceStatus = getAdjustPriceStatus(this.order);
            if (adjustPriceStatus.pending === 0) {
              this.setSharable();
            } else {
              wx.hideOptionMenu();
            }
          });
        } catch (error) {
          console.log("wx.reday error");
        }
      },
    },
  },
  mounted() {
    const teleport = document.querySelector("#layout-top-teleport");
    // console.log("mounted", teleport, this.$el);
    teleport.innerHTML = "";
    teleport.appendChild(this.$el);
  },
  destroyed() {
    document.querySelector("#layout-top-teleport").innerHTML = "";
    try {
      wx.ready(() => {
        wx.hideOptionMenu();
      });
    } catch (error) {
      console.log("wx.reday error");
    }
  },
  methods: {
    async setSharable() {
      const that = this;
      try {
        wx.showOptionMenu();
        wx.onMenuShareAppMessage({
          title:
            this.order.status === 20
              ? this.brandInfo.resetLogisticsShareTitle
              : this.brandInfo.h5ShareTitle, // 分享标题
          desc: this.order.status === 20 ? "请您选择取货方式" : "点击查看详情", // 分享描述
          enterChat: false,
          link:
            location.href.split("#")[0] +
            "#" +
            "/customer/order?orderNo=" +
            this.order.orderNo +
            "&salesWwid=" +
            this.order.salesWwid,
          imgUrl: this.brandInfo.shareImage,
          success: function () {
            that.$toast("发送成功");
            if (that.order.status === 0) {
              that.changeOrder();
            } else if (that.order.status === 20) {
              window.WeixinJSBridge.call("closeWindow");
            }
          },
        });
      } catch (error) {
        console.log("setSharable error", error);
      }
    },
    changeOrder() {
      changeOrderApi(this.order.id).then(() => {
        window.WeixinJSBridge.call("closeWindow");
      });
    },
  },
};
</script>

<style lang="less" scoped>
.order-share-tips {
  gap: 9/20rem;

  position: relative;
  box-sizing: border-box;
  width: 100vw;
  height: 60/20rem;
  padding-right: 15/20rem;
  background-color: #000;
  color: #fff;

  line-height: 18/20rem;
  font-weight: 400;
  font-size: 13/20rem;

  letter-spacing: 0;

  .find-more-icon {
    width: 18/20rem;
    height: 4/20rem;
  }

  .upward {
    width: 20/20rem;
    height: 24/20rem;
    margin-left: 6/20rem;
  }
}
</style>
